import { jsx as r } from "react/jsx-runtime";
import { MinusIcon as t, CheckmarkIcon as i } from "../../icons/index.es.js";
const f = ({ isChecked: e, isIndeterminate: n, sx: o }) => {
  if (n)
    return /* @__PURE__ */ r(t, { boxSize: 4, sx: o });
  if (e)
    return /* @__PURE__ */ r(i, { boxSize: 4, sx: o });
};
export {
  f as getCheckboxIcon
};
//# sourceMappingURL=Checkbox.utils.es.js.map
